// Filter providers by region
$('.region-filter').change(function () {
    let regionsChecked = $('.region-filter:checked'),
    list = $(".centre");

    if (regionsChecked.length === 0) {
        $(list).show();
    } else {
        $(list).hide();
        regionsChecked.each(function () {
            let region = $(this).attr('value');

            if ($(this).attr('value') === 'All') {
                $(list).show();
                return;
            }

            list.each(function () {
                if ($(this).attr('data-custom-type') === region) {
                    $(this).show();
                }
            });
        });
    }
    $('.centres-map').trigger('initialize');
}).filter(':checked').trigger('change')

$('.show-all').click(function () {
    let list = $(".centre");
    $(list).show();
    let checkboxes = $('.region-filter');

    checkboxes.each(function () {
        if ($(this).val() === 'All' && !$(this).prop('checked')) {
            $(this).click();
        } else if ($(this).val() !== 'All' && $(this).prop('checked')) {
            $(this).click();
        }
    });
});

// Initialize providers map
$('.centres-map').each(function () {
    let map = L.map(this).setView([-41.29260796538415, 174.7768093624618], 13),
        markers = L.layerGroup().addTo(map);

    //Add tiles
    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map);

    // const markerColors = ['green', 'pink', 'blue', 'orange', 'yellow'];

    //Add markers
    $(this).on('initialize', function () {
        var maxLat, minLat, maxLng, minLng;
        //Clear old markers
        markers.clearLayers();

        let counter = 0;
        $('.centres-list .centre:visible').each(function () {
            if (!$(this).data('lat')) return;

            // if (counter >= markerColors.length) {
            //     counter = 0;
            // }

            // let myIcon = L.icon({
            //     // iconUrl: '_resources/themes/accesschoice/images/map-marker-' + markerColors[counter++] + '.svg',
            //     iconSize: [28, 28],
            //     iconAnchor: [18, 28],
            //     popupAnchor: [-3, 36],
            //     shadowSize: [68, 95],
            //     shadowAnchor: [18, 28]
            // });

            L.marker([$(this).data('lat'), $(this).data('long')])
                .bindPopup($(this).find('.text').html())
                .addTo(markers);
            //Keep track of min/max lat/lng
            if (!maxLat || $(this).data('lat') > maxLat) maxLat = $(this).data('lat');
            if (!minLat || $(this).data('lat') < minLat) minLat = $(this).data('lat');
            if (!maxLng || $(this).data('long') > maxLng) maxLng = $(this).data('long');
            if (!minLng || $(this).data('long') < minLng) minLng = $(this).data('long');
        });

        //Set bounding box
        map.fitBounds([
            [maxLat, maxLng],
            [minLat, minLng]
        ])

        //Make sure it's not too zoomed in
        if (map.getZoom() > 13) map.setZoom(13);
    }).trigger('initialize');
})
